export default __webpack_public_path__ + "0c7d638.png";